import React, { useRef, useState, useLayoutEffect } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { useGLTF, useTexture, AccumulativeShadows, RandomizedLight, Decal, Environment, Center } from "@react-three/drei";
import { EffectComposer, Bloom, BrightnessContrast, HueSaturation } from "@react-three/postprocessing";
import { proxy } from "valtio";

const state = proxy({
    intro: true,
    colors: ["#ccc", "#EFBD4E", "#80C670", "#726DE8", "#EF674E", "#353934"],
    decals: ["/models/Kevin_actorScan_Diffuse.png", "/models/Kevin_actorScan_Normal.png", "/models/Kevin_actorScan_Opacity.jpg"],
    color: "#EFBD4E",
    decal: "/models/Kevin_actorScan_Diffuse.png",
});

function Cylinder3d() {
    return (
        <Canvas shadows camera={{ position: [0, 6, 14], fov: 20 }} gl={{ preserveDrawingBuffer: true }}>
            <ambientLight intensity={0.1} />
            <Environment files="https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/potsdamer_platz_1k.hdr" />
            <Shirt />
            <EffectComposer disableNormalPass>
                <Bloom luminanceThreshold={0.1} mipmapBlur />
                <BrightnessContrast brightness={-0.05} contrast={0.05} />
                <HueSaturation hue={0} saturation={0.2} />
            </EffectComposer>
        </Canvas>
    );
}

function Shirt(props) {
    const ref = useRef();
    useLayoutEffect(() => {
        ref.current?.updateMorphTargets();
    }, []);
    const { nodes, materials } = useGLTF("/models/Character.glb");
    return (
        <group {...props} dispose={null}>
            {/* <mesh geometry={nodes["Kevin_actorScan"]?.geometry} material={materials?.Kevin_actorScan} /> */}
            <mesh ref={ref} castShadow receiveShadow geometry={nodes.CC_Base_Body001_8.geometry} material={materials.Kevin_actorScan} scale={0.1} position={[0, 0, 0]} rotation={[0, 0, 0]}></mesh>
        </group>
    );
}

// useGLTF.preload("/models/Character.glb");
// ["/models/Kevin_actorScan_Diffuse.png", "/models/Kevin_actorScan_Normal.png"].forEach(useTexture.preload);

export default Cylinder3d;
